<template>
  <div ref="customCursor" class="fancy mb-flexMobile h-auto montserrat container mx-auto w-full flex justify-center items-center">
    <div ref="cardsContainer" class="relative flex justify-center items-center bg-center overflow-hidden">
      <!-- Cards -->
      <div class="relative flex w-full justify-center items-center gap-6">
        <div
          v-for="(image, index) in images"
          :key="index"
          :class="`card-container w-full md:w-[45%] relative hover-trigger transition-transform duration-500 ease-in-out ${!index ?`put`:``}`"
        >
          <router-link :to="image.link" class="block h-full">
            <!-- Card Content -->
            <img
              :src="image.src"
              :alt="image.alt"
              class="w-full h-[500px] object-cover rounded-lg shadow-lg card-image index==0?stay : "
            />
            <!-- Hover Image -->
            <div class="hover-image-container">
              <img
                v-if="image.hoverSrc"
                :src="image.hoverSrc"
                :alt="`${image.alt} hover`"
                class="hover-image"
              />
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FullWidthSlider',
  data() {
    return {
      images: [
        {
          src: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244966/adyrvr80i6rlxypnmxva.png",
          hoverSrc: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244966/rtuwc73817leq9q2ncjr.png",
          alt: "Group 5",
          link: "/BakeryProject",
        },
        {
          src: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/vju9q0c1ihnrtrbevn57.png",
          hoverSrc: "https://res.cloudinary.com/dvkj5orhe/image/upload/v1732244965/n7jud9wnjdx907hwefla.png",
          alt: "Group 6",
          link: "/NextProject",
        },
      ],
    };
  },
};
</script>

<style>
.stay{
  margin-top : 15px 
}
.put{
  margin-top: -35px;
 
}
.top{
  margin-top: 25px;
}
.card-container {
  position: relative;
  flex: 1;
  transition: transform 0.3s ease-in-out, flex 0.3s ease-in-out;
}

.card-container:hover {
  transform: scale(1.1); /* Enlarge hovered card */
  flex: 1.65; /* Slightly larger space */
}

.card-container:not(:hover) {
  transform: scale(0.9); /* Shrink non-hovered cards */
  flex: 0.5; /* Slightly smaller space */
}

.hover-trigger {
  position: relative;
  overflow: visible;
}

.card-image {
  width: 90%;
  height: 90%;
  object-fit: cover;
  border-radius: 8px;
  transition: opacity 0.3s ease-in-out; /* Add opacity transition */
  z-index: 1; /* Keep it below the hover image */
}

.card-container:hover .card-image {
  opacity: 0; /* Hide the unhovered image */
}

.hover-image-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 10; /* Ensure it's above the original image */
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.hover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-container:hover .hover-image-container {
  opacity: 1; /* Show the hover image */
  transform: translate(-50%, -50%) scale(0.7);
}

/* Mobile styles */
@media (max-width: 768px) {
  .card-container {
    flex: 1;
    transform: none !important;
  }

  .card-container:hover {
    transform: none !important;
    flex: 1;
  }

  .card-image, .hover-image-container {
    opacity: 1 !important; /* Always visible on mobile */
  }
}

</style>